import StoreInstance, { Store } from './Store'

export default StoreInstance
export { Store }
